module.exports = __webpack_public_path__ + "static/mailMagazineImage-42b14c74d5443ce5cc5bff581532f0d9.png";